(() => {
  const CONTROL_SELECTOR = '[data-cookie-preferences]';
  const MAX_ATTEMPTS = 8;
  const RETRY_DELAY_MS = 250;
  const pendingControls = new WeakSet();

  const wait = () => new Promise((resolve) => window.setTimeout(resolve, RETRY_DELAY_MS));

  async function showPreferences(control) {
    if (pendingControls.has(control)) return;
    pendingControls.add(control);

    try {
      for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt += 1) {
        const privacyBanner = window.privacyBanner;

        if (typeof privacyBanner?.showPreferences === 'function') {
          try {
            await privacyBanner.showPreferences();
          } catch (error) {
            console.warn('[Syl\u2019a\u2019Vie] Shopify cookie preferences could not be opened.');
          }
          return;
        }

        if (attempt < MAX_ATTEMPTS - 1) await wait();
      }

      console.warn('[Syl\u2019a\u2019Vie] Shopify cookie preferences are unavailable.');
    } catch (error) {
      console.warn('[Syl\u2019a\u2019Vie] Shopify cookie preferences are unavailable.');
    } finally {
      pendingControls.delete(control);
    }
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest?.(CONTROL_SELECTOR);
    if (!control) return;

    void showPreferences(control);
  });
})();
